import React, { SetStateAction } from 'react'
import { Input } from 'components/Input/Input'
import { Animation, Button, Flex, ItemsGrid, TabFooter } from 'styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { ISingleIssue } from 'types/issues.interface'

export const IssueInfo = ({ state, setState, handleSubmit }: IIssueInfoTab) => {
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = e.target as HTMLInputElement
    setState({ ...state, [name]: value })
  }


  return (
    <>
      <Animation>
        <ItemsGrid columns={2} width='50%'>
          <Input
            value={state.name}
            labelText='Issue Title'
            onChange={handleChange}
            name='name'
            placeholder='Enter name'
            invalid={state.name.length < 2}
          />

        </ItemsGrid>
        <TabFooter>
          <Flex end='true' gap='1em'>
            <CancelBtn />
            <Button orange type='button' onClick={handleSubmit}>
              Save
            </Button>
          </Flex>
        </TabFooter>
      </Animation>
    </>
  )
}

interface IIssueInfoTab {
  state: ISingleIssue
  setState: React.Dispatch<SetStateAction<ISingleIssue>>
  handleSubmit: () => void
}
